import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

interface SignedUploadResponse {
  key: string;
  url: string;
  headers: Record<string, string | string[]>;
}

export interface UploadedFileReference {
  key: string;
  originalName: string;
}

@Injectable({
  providedIn: 'root',
})
export class SignedUploadService {
  constructor(private http: HttpClient) {}

  async upload(file: File): Promise<UploadedFileReference> {
    const signed = await firstValueFrom(
      this.http.post<SignedUploadResponse>(`${environment.apiUrl}/api/uploads/sign`, {
        filename: file.name,
        content_type: file.type || 'application/octet-stream',
        size: file.size,
      }),
    );

    const response = await fetch(signed.url, {
      method: 'PUT',
      headers: this.normalizeHeaders(signed.headers),
      body: file,
    });

    if (! response.ok) {
      throw new Error('Failed to upload the selected file.');
    }

    return {
      key: signed.key,
      originalName: file.name,
    };
  }

  private normalizeHeaders(headers: Record<string, string | string[]>): Record<string, string> {
    return Object.entries(headers).reduce<Record<string, string>>((normalized, [key, value]) => {
      if (key.toLowerCase() === 'host') {
        return normalized;
      }

      normalized[key] = Array.isArray(value) ? value.join(', ') : value;

      return normalized;
    }, {});
  }
}
